<template>
    <div ref="chartContainer">
        <highcharts v-if="Object.keys(chartData).length" :options="chartData" ref="chart" />
    </div>
</template>
<script>
export default {
    name: "AreaLineChart",
    data() {
        return {
            chartData: {},
        }
    },
    props: {
        rawData: {
            type: Array,
            required: true
        }
    },
    mounted() {
        this.plotChart();
        this.resizeObserver = new ResizeObserver(() => {
            this.resizeChart();
        });
        this.resizeObserver.observe(this.$refs.chartContainer);
    },
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    },
    watch: {
        rawData: {
            handler() {
                this.plotChart()
            },
            deep: true
        }
    },
    methods: {
        resizeChart() {
            if (this.$refs.chart.chart) {
                this.$refs.chart.chart.reflow();
            }
        },
        plotChart() {
            let categoriesData = [];
            let seriesData = [];

            this.rawData.map(datapoint => {
                categoriesData.push(datapoint.date);
                seriesData.push(datapoint.rating);
            });

            this.chartData = {
                chart: {
                    type: 'areaspline'
                },
                title: {
                    text: ''
                },
                legend: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                exporting: {
                    enabled: false,
                },
                xAxis: {
                    categories: categoriesData,
                    tickmarkPlacement: 'on',
                    title: {
                        enabled: false
                    },
                    labels: {
                        style: {
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            fontWeight: '500',
                            lineHeight: '16px',
                            textAlign: 'center',
                            color: '#A1A1A1'
                        },
                        y: 30,
                        formatter: function () {
                            return this.value.substring(0, 3);
                        },
                    }
                },
                yAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        enabled: false
                    },
                    gridLineColor: '#E4EDEE',
                    gridLineWidth: 1.5,
                    gridLineDashStyle: 'Dash'
                },
                tooltip: {
                    shared: true,
                    borderWidth: 1,
                    borderColor: "rgba(212, 212, 212, 1)",
                    shadow: {
                        color: "#d6d6d6",
                        opacity: 0.1,
                        width: 10,
                    },
                    borderRadius: 15,
                    backgroundColor: "#ffffff",
                    style: {
                        fontSize: "16px"
                    },
                    padding: 10,
                    formatter: function () {
                        return this.x + ': <b>' + this.y.toFixed(2) + '</b>';
                    }
                },
                plotOptions: {
                    areaspline: {
                        fillOpacity: 0.5,
                        marker: {
                            enabled: true,
                            radius: 6,
                            fillColor: 'white',
                            lineWidth: 2,
                            lineColor: null
                        },
                    }
                },
                series: [{
                    name: 'Performance',
                    data: seriesData,
                    color: '#065559',
                    fillColor: {
                        linearGradient: {
                            x1: 0,
                            y1: 0,
                            x2: 0,
                            y2: 1
                        },
                        stops: [
                            [0, 'rgba(0, 85, 90, 0.5)'],
                            [1, 'rgba(0, 150, 136, 0.045)']
                        ]
                    }
                }]
            }
        }
    }
}
</script>